// eslint-disable-next-line no-shadow
export enum HubriseEventType {
    CREATE = 'create',
    DELETE = 'delete',
    PATCH = 'patch',
    UPDATE = 'update'
}
